import { connect, useDispatch } from 'react-redux';
import * as $ from 'jquery';
import Moment from 'moment';
import { orderEdit, orderCreate, ordersLoad } from '../../../redux/actions/order/orderActions';
import { appointmentLoad } from '../../../redux/actions/appointmentActions';
import { staffsLoad } from '../../../redux/actions/staffActions';
import { claimFormReset } from '../../../redux/actions/order/claimFormActions';
import { tabChange } from '../../../itrust_common/redux/actions/otherActions';
import Alert from '../../../itrust_common/components/Alert';
import { patientReportsLoad } from '../../../itrust_common/redux/actions/settingActions/patientReportActions';
import { onBoardingTourInfoReset } from '../../../redux/actions/onBoardingActions';
import { visionInsuranceClaimFormReset } from '../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction';
import { storeStaffsLoad } from '../../../redux/actions/currentStoreActions';
import { storeSettingLoad } from '../../../redux/actions/storeSettings/storeSettingActions';
import { templateLoad } from '../../../itrust_common/redux/actions/settingActions/templateActions';
import moment from 'moment';

function CreateOrderButton(props) {
  const { children, patientId, appointmentId, currentUser, activeTourType, store, patient, patientName, hasTodayOrder, orders, alertMessages } = props
  let staffId = currentUser.id
  const dispatch = useDispatch()
  const includeArr = ['staff', 'procedures', 'patient', 'notes', 'eyeglasses', 'contact_lenses', 'misc_items']

  const createParams = { status: 'unfinished', order_date: Moment(new Date()).format("YYYY/MM/DD"), patient_id: patientId, staff_id: staffId, appointment_id: appointmentId }

  const handleOrderSubmit = async (data) => {
    const hasTodayOrder = await handleOrdersLoad()
    const alertMessage = hasTodayOrder ? 'An order from today already exist for' : 'You’re creating a new order for'

    let localStorageStoreId = localStorage.getItem('StoreID')
    if (activeTourType === 'create_order') {
      dispatch(onBoardingTourInfoReset(activeTourType))
    }

    if (localStorageStoreId == null) {
      Alert.warning("Please select store from top dropdown.")
    }
    else {
      Alert.confirm(
        <div className="d-flex">{alertMessage} <strong className="px-2">
          {patientName ?? patient.name}</strong> at <strong className="px-2">{store.name}</strong>.</div>,
        (response) => {
          if (response) {
            if (localStorageStoreId && localStorageStoreId !== 'null') {
              dispatch(storeStaffsLoad(localStorageStoreId, { rpp: 1000, filter: { doctor: localStorageStoreId } }))
              dispatch(storeSettingLoad({ filter: { store_id: localStorageStoreId }, page: 1, rpp: 999999999, sort: 'position', direction: 'asc' }))
            }
            dispatch(claimFormReset())
            dispatch(visionInsuranceClaimFormReset())
            dispatch(tabChange({ order: 1 }))
            dispatch(templateLoad({ filter: { category: 'orders' } }))
            dispatch(orderCreate(data, { include: '*' })).then((response) => {
              let res = response.value.data.order
              dispatch(orderEdit(res.id));
              dispatch(patientReportsLoad({ patient_id: res.patient_attributes.id, staff_id: res.staff_id, store_id: res.store_attributes.id, filter: { category: "invoice" } }))
              dispatch(staffsLoad({ rpp: 9999, filter: { selected_store: store.id } }))
              //Load appointment if order created from appointment
              if (appointmentId) {
                dispatch(appointmentLoad(appointmentId, { include: ['patient', 'staff', 'procedures', 'examination', 'order'] }))
              }
              $('#orderForm-modal').modal('show');
            })
          }
        }
      )
    }
  }

  const handleOrdersLoad = async () => {
    let orders = await dispatch(ordersLoad({ rpp: 500, direction: "desc", sort: "created_at", badge_type: 'patient_profile_count_cards', filter: { patient: patientId }, include: includeArr }));
    orders = orders?.value?.data?.orders || [];
    const hasTodayOrder = orders.some((order) => new Date(order.order_date).toDateString() === new Date().toDateString()) // check if today's older already exist
    return hasTodayOrder ? true : false
  }

  return (
    <span className="pointer" onClick={() => handleOrderSubmit(createParams)}>
      {children}
    </span>
  )
}


function mapStateToProps(state) {
  const { patient, currentStore, auth } = state;
  return {
    patient: patient.patient,
    store: currentStore.store,
    currentUser: auth.user
  };
}

export default connect(mapStateToProps)(CreateOrderButton);